export class GeneralOldResponse {
    success: boolean|null;
    method: string|null;
    statusCode: number|null;
    serviceErrorCode: string|null;

    constructor(success?:boolean, method?:string, statusCode?:number, serviceErrorCode?:string) {
        this.success = success ?? null;
        this.method = method ?? null;
        this.statusCode = statusCode ?? null;
        this.serviceErrorCode = serviceErrorCode ?? null;
    }
}

export class DataResponse extends GeneralOldResponse {
    data:any;

    constructor() {
        super();
        this.data = {};
    }
}

export class FileResponse extends GeneralOldResponse{
    fileID:number|null = null;
    fK_UserID:number|null = null;
    creatorName:string|null = null;
    fileName:string = "";
    fileDesc:string = "";
    fileType:string = "";
    fileSize:number|null = null;
    downloadURLGuid:string = "";
    deleteToDate:any = undefined; //DateTime?
    remindAboutDeleteDate:any = undefined; //DateTime?
    reminderSend:boolean = false;
    created:any = undefined; //DateTime?
    changed:any = undefined; //DateTime?
    deleted:any = undefined; //DateTime?
    deletedToken:string = "";
    content:any = undefined; //FileStream?
    isCompleted:boolean = false;
}

export class TicketResponse extends GeneralOldResponse{
    ticketID:number|null = null;
    ticketType:number|null = null;
    fK_UserID:number = -1;
    creatorName:string|null = null;
    fK_FileID:number = -1;
    fileName:string|null = null;
    authToEmail:string|null = null;
    attemptsRemaining:number|null = null;
    validToDate:any = null; // DatemTime?
    urlGuid:string|null = null;
    oneTimePassword:string|null = null;
    oneTimePasswordLifeTime:any = null; // DatemTime?
    created:any = null; // DatemTime?
    changed:any = null; // DatemTime?
    deleted:any = null; // DatemTime?
    deletedToken:string|null = null;
    changedByUserID:number|null = null;
    changedByUserName:string|null = null;
    messageToRecipient: string|null = null;
    recipientName:string|null = null;
}

export class RecipientResponse extends GeneralOldResponse{
    recipientID:number|null = null;
    fK_UserID:number|null = null;
    creatorName:string|null = null;
    recipientName:string|null = null;
    recipientLastName:string|null = null;
    recipientEmail:string|null = null;
    changed:any = null; //DateTime?
    created:any = null; //DateTime?
    deleted:any = null; //DateTime?
    deletedToken:string|null = null;

    contains:boolean|null = null;
}

export class RecipientlistResponse extends GeneralOldResponse{
    recipientlistID:number|null = null;
    fK_UserID:number|null = null;
    creatorName:string|null = null;
    recipientlistName:string|null = null;
    recipientlistDesc:string|null = null;
    changed:any = null; //DateTime?
    created:any = null; //DateTime?
    deleted:any = null; //DateTime?
    deletedToken:string|null = null;
    recipientlistCount:number|null = null;

    contains:boolean|null = null;
}

export class UserResponse extends GeneralOldResponse{
    userID:number|null = null;
    userName:string|null = null;
    userLastName:string|null = null;
    userEmail:string|null = null;
    userRole:string|null = null;
    isDownloadPushMailActive:boolean|null = null;
    isUploadPushMailActive:boolean|null = null;
    isDeletePushMailActive:boolean|null = null;
}

export class RecipientToRecipientlistsResponse extends GeneralOldResponse{
    recipient:RecipientResponse|null = null;
    recipientlists:Array<RecipientlistResponse>|null = null;
}

export class RecipientlistToRecipientsResponse extends GeneralOldResponse{
    recipientlist:RecipientlistResponse|null = null;
    recipients:Array<RecipientResponse>|null = null;
}

export class ServiceConfigResponse extends GeneralOldResponse{
    daysToDeleteFiles:number|null = null;
    daysToDeleteUnusedTickets:number|null = null;
    daysToBeValidForTickets:number|null = null;
    daysToKeepLogs:number|null = null;
    hoursForOTPToBeValid:number|null = null;
    daysToRemindBeforeDeletion:number|null = null;
    standardAndLimitOfAttempts:number|null = null;
}

export class StartupConfigResponse extends GeneralOldResponse{
    impressum:string = "";
    datenschutz:string = "";
    disclaimer:string = "";
    authUrl:string = "";
    clientId:string = "";
    clientScopes:string = "";
}